import { render, staticRenderFns } from "./verifyAccount.vue?vue&type=template&id=fc55d138&scoped=true&"
import script from "./verifyAccount.vue?vue&type=script&lang=js&"
export * from "./verifyAccount.vue?vue&type=script&lang=js&"
import style0 from "./verifyAccount.vue?vue&type=style&index=0&id=fc55d138&lang=sass&scoped=true&"
import style1 from "./verifyAccount.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc55d138",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
